<template>
  <div class="items-list">
    <ul class="items">
      <li class="items__item" v-if="!isEditPeriod">
        <div class="items__item__content">
          <p>Periode</p>
          <div class="input-group__input">
            {{ dateRangeFormatted }}
            <div class="hint--right" aria-label="Redigér periode">
              <div class="icon__bg-circle" @click="isEditPeriod = true"><span class="icon-wrench"></span></div>
            </div>
          </div>
        </div>
      </li>
      <template v-if="isEditPeriod">
        <li class="items__item">
          <div class="items__item__content">
            <p>Startdato</p>
            <div class="input-group__input">
              <DateSelector
                :date="startDate"
                @changed="setStartDate"
              ></DateSelector>
            </div>
          </div>
        </li>
        <li class="items__item">
          <div class="items__item__content">
            <p>Slutdato</p>
            <div class="input-group__input">
              <DateSelector
                :date="endDate"
                @changed="setEndDate"></DateSelector>
            </div>
          </div>
        </li>
      </template>
      <li class="items__item">
        <div class="items__item__content">
          <p>Stillingsprosenten</p>
          <div class="input-group__input">
            <span class="label">%</span>
            <input type="number"
                   v-model="employmentPercentage.hours"
                   @change="employmentPercentageChanged($event.target.value)"
                   @focus="$event.target.select()">
          </div>
        </div>
      </li>
      <li class="items__item" :class="{'items__item--fixed': workingHours.isFixed}">
        <div class="items__item__content">
          <p>{{ workingHours.title }}</p>
          <div class="input-group__input">
            <span class="label">timer</span>
            <input type="number" v-model="workingHours.hours"
                   @change="onEditWorkingHours($event.target.value)"
                   @focus="$event.target.select()">
          </div>
        </div>
      </li>
      <li class="items__item" :class="{'items__item--fixed': planleggingsdager.isFixed}">
        <div class="items__item__content">
          <p>{{ planleggingsdager.title }}</p>
          <div class="input-group__input">
            <span class="label">timer</span>
            <input type="number" v-model="planleggingsdager.hours"
                   @change="onEditPlanleggingsdager($event.target.value)"
                   @focus="$event.target.select()">
          </div>
        </div>
      </li>
      <div class="item__total">
        <p>Sum arbeidstid i 38 uker</p>
        <p>{{ workingHoursWithoutPlanleggingsdager }} timer</p>
      </div>
      <label class="d-label marg-1-bottom" v-if="true">Reduksjon til undervisning</label>
      <ul>
        <li class="subtract-item items__item" v-for="(subtractItem, idx) in subtractedItems" :key="subtractItem.id">
          <template v-if="subtractItem.id === 'reduction_employee_percentage'">
          <p style="margin-left: 19px">
            Stillingsprosenten reduksjon</p><p>{{ subtractItem.hours }}%</p>
          </template>
          <template v-else>
            <div class="subtract-item__title">
              <div class="d-input-group__input__close icon__bg-circle icon__bg-circle--danger"
                   @click="deleteItem(subtractItem)">
                <span class="icon-cross2"></span>
              </div>
              {{ subtractItem.title }}
            </div>
            <div class="input-group__input" v-if="subtractItem.isOwn" >
              <span class="label">{{ subtractItem.unit ? subtractItem.unit : 'timer' }}</span>
              <input type="number" v-model="subtractItem.hours" @focus="$event.target.select()"
                     @change="setSubtractedItemValue(subtractItem, $event.target.value)">
            </div>
            <p v-else>{{ subtractItem.hours }}%</p>
          </template>
        </li>
      </ul>
    </ul>
    <ul class="items" id="items__list">
      <li class="items__item items__item__add__new" v-if="isAddNew">
        <input type="text" placeholder="" ref="add_new_input" v-model="newItemTitle"
               @keydown.enter="addOwn">
        <div class="items__item__add__new__buttons">
          <button class="bttn" @click="reset">Annullér</button>
          <button class="bttn bttn-primary" @click="addOwn">Gem</button>
        </div>
      </li>
    </ul>
    <DDropdown :isShowDots="false" class="add-more__dropdown">
      <p slot="title" class="items__item__add" v-if="!isAddNew">+ Legg til reduksjon</p>
      <ul slot="list">
        <label class="d-label d-label__headline">Livsfasetiltak</label>
        <li v-for="(possibleItem, idx) in possibleStandardItems" @click="addFromStandard(possibleItem)">{{
            possibleItem.title
          }}
        </li>
        <li class="items__item__add" style="border-top: 1px solid #ddd;margin-top: 0.5rem" @click="setIsAddNew(true)">+
          Lag din egen
        </li>
      </ul>
    </DDropdown>
  </div>
</template>

<script>
import DDropdown from '../common/DDropdown'
import DateSelector from '../datepicker/DateSelector'
import moment from 'moment'

export default {
  components: {DDropdown, DateSelector},
  props: {
    schoolYear: {},
    theEditUserNorm: {
      type: Array,
      default: () => []
    },
    isNetto: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      isEditPeriod: false,
      initStartDate: null,
      initEndDate: null,
      startDate: null,
      endDate: null,
      employmentPercentage: {
        id: 'employment_percentage',
        title: 'Stillingsprosenten',
        hours: 100,
        standardHours: 100,
        unit: '%',
        isFixed: false
      },
      workingHours: {
        id: 'working_hours',
        title: 'Årsverk',
        hours: 1687.5,
        standardHours: 1687.5,
        isFixed: true
      },
      planleggingsdager: {
        id: 'planleggingsdager',
        title: 'Planleggingsdager',
        hours: 45,
        standardHours: 45,
        isFixed: true
      },
      teachingPercentage: {
        id: 'working_hours',
        title: 'Undervisningsprosent',
        hours: 100,
        standardHours: 100,
        unit: 'percentage',
        isFixed: true
      },
      standardItems: [
        {
          id: 'reduction_employee_percentage',
          title: 'Stillingsprosenten reduksjon',
          hours: 0,
          standardHours: 0,
          unit: '%',
          isSelected: false,
          isHide: true
        },
        {
          id: 'reduction_newly_educated',
          title: 'Første yrkesåret etter utdanning',
          hours: 6,
          standardHours: 6,
          unit: '%',
          isSelected: false
        },
        {
          id: 'reduction_57_60',
          title: 'Fra 57 år til og med 59 år',
          hours: 6,
          standardHours: 6,
          unit: '%',
          isSelected: false
        },
        {
          id: 'reduction_60',
          title: '60 år og eldre',
          hours: 12.5,
          number: 12.5,
          year_hours_reduction: 37.5,
          standardHours: 12.5,
          unit: '%',
          isSelected: false
        }
      ],
      isEdit: false,
      isAddNew: false,
      newItemTitle: '',
      danishHolidays: [
        '01-01-2022',
        '10-04-2022',
        '14-04-2022',
        '15-04-2022',
        '17-04-2022',
        '18-04-2022',
        '13-05-2022',
        '26-05-2022',
        '05-06-2022',
        '06-06-2022',
        '05-06-2022',
        '24-12-2022',
        '25-12-2022',
        '26-12-2022',
        '31-12-2022',
        '01-01-2023',
        '02-04-2023',
        '06-04-2023',
        '07-04-2023',
        '09-04-2023',
        '10-04-2023',
        '05-05-2023',
        '18-05-2023',
        '28-05-2023',
        '29-05-2023',
        '24-12-2023',
        '25-12-2023',
        '26-12-2023',
        '31-12-2023',
        '01-01-2024',
        '24-03-2024',
        '28-03-2024',
        '29-03-2024',
        '31-03-2024',
        '01-04-2024',
        '09-05-2024',
        '19-05-2024',
        '20-05-2024',
        '25-12-2024',
        '26-12-2024',
        '01-01-2025',
        '13-04-2025',
        '17-04-2025',
        '18-04-2025',
        '20-04-2025',
        '21-04-2025',
        '29-05-2025',
        '08-06-2025',
        '09-06-2025',
        '25-12-2025',
        '26-12-2025',
        '01-01-2026',
        '29-03-2026',
        '02-04-2026',
        '03-04-2026',
        '05-04-2026',
        '06-04-2026',
        '01-05-2026',
        '14-05-2026',
        '24-05-2026',
        '25-05-2026',
        '05-06-2026',
        '24-12-2026',
        '25-12-2026',
        '26-12-2026',
        '31-12-2026'
      ]
    }
  },
  computed: {
    workingHoursWithoutPlanleggingsdager () {
      return (this.workingHours.hours - this.planleggingsdager.hours).toFixed(2)
    },
    dateRangeFormatted () {
      return moment(this.startDate).format('ll') + ' - ' + moment(this.endDate).format('ll')
    },
    subtractedItems () {
      return this.standardItems.filter(item => item.isSelected)
    },
    possibleStandardItems () {
      return this.standardItems.filter(item => {
        return !item.isSelected && !item.isHide
      })
    },
    nettoTime () {
      return parseFloat(this.workingHours.hours).toFixed(2)
    },
    itemsToSave () {
      const startDate = moment(this.startDate).format('YYYY-MM-DD')
      const endDate = moment(this.endDate).format('YYYY-MM-DD')
      const periodStart = {
        id: 'period_start',
        title: 'hidden_periode_start',
        isChecked: true,
        value: startDate,
        hours: startDate
      }
      const periodEnd = {id: 'period_end', title: 'hidden_periode_end', isChecked: true, value: endDate, hours: endDate}
      const periodDates = {title: 'Periode', value: this.dateRangeFormatted}
      let arr = [periodStart, periodEnd, periodDates]
      arr.push({title: this.employmentPercentage.title, value: this.employmentPercentage.hours + '%'})
      arr.push({title: 'hidden_stillingsprosenten', hours: this.employmentPercentage.hours})
      arr.push(this.workingHours)
      arr.push({title: this.planleggingsdager.title, hours: this.planleggingsdager.hours * 1})
      arr.push({title: 'Sum af arbedstid i 38 uker', hours: this.workingHoursWithoutPlanleggingsdager * 1})
      this.subtractedItems.forEach(item => {
        const hiddenName = 'hidden_reduction_teaching_' + item.id
        const hours = item.hours * 1
        const value = item.hours + '%'
        console.log({value})
        arr.push({title: hiddenName, value: hours})
        arr.push({title: item.title, value: value, dontValidate: true})
      })
      return arr
    },
    numberOfSchoolDays () {
      function isNotWeekend (m) {
        return moment(m).isoWeekday() !== 6 && moment(m).isoWeekday() !== 7
      }

      let startDate = this.startDate
      const endDate = this.endDate
      const dateArray = []
      while (moment(startDate).isSameOrBefore(endDate)) {
        const m = moment(startDate).format('YYYY-MM-DD')
        if (isNotWeekend(m)) {
          dateArray.push(m)
        }
        startDate = moment(startDate).add(1, 'days')
      }
      return dateArray.length
    },
    isOnlyPartOfSchoolYear () {
      const initStartDateFormatted = this.initStartDate.format('YYYY-MM-DD')
      const startDateFormatted = this.startDate.format('YYYY-MM-DD')
      const initEndDateFormatted = this.initEndDate.format('YYYY-MM-DD')
      const endDateFormatted = this.endDate.format('YYYY-MM-DD')
      return initStartDateFormatted !== startDateFormatted || initEndDateFormatted !== endDateFormatted
    }
  },
  watch: {
    itemsToSave () {
      this.$emit('updated', this.itemsToSave)
    },
    nettoTime () {
      this.$emit('changedSum', this.nettoTime)
    },
    theEditUserNorm () {
      this.isEdit = true
      this.standardItems.forEach((standardItem, idx) => {
        this.standardItems[idx].isSelected = false
      })
      this.initStartAndEndDate()
      this.theEditUserNorm.forEach(normItem => {
        const normItemHours = normItem.value * 1
        switch (normItem.title) {
          case 'Periode start':
          case 'hidden_periode_start':
            this.setStartDate(normItem.value)
            break
          case 'Periode slut':
          case 'hidden_periode_end':
            this.setEndDate(normItem.value)
            break
          case 'Årsværk':
            this.workingHours.title = normItem.title
            this.$emit('onEditNetto')
            this.workingHours.hours = normItemHours
            break
          case 'hidden_stillingsprosenten':
            this.employmentPercentage.hours = normItemHours
            break
          case 'Periode':
          case 'Stillingsprosenten':
          case 'Arbejdstid':
            break
          default:
            const idx = this.standardItems.findIndex(item => item.title === normItem.title)
            if (idx > -1) {
              this.standardItems[idx].hours = normItemHours
              this.standardItems[idx].isSelected = true
            } else {
              this.addOwn(normItem)
            }
            break
        }
      })
    },
    numberOfSchoolDays () {
      this.initData()
    },
    isNetto () {
      if (!this.isEdit) {
        this.initStartAndEndDate()
      }
      this.initData()
    }
  },
  methods: {
    initData () {
      // Dont calculate hours if a user is edited - unless the employmentperiod changes
      if (this.isEdit) {
        return
      }
      let hoursInPeriod = 1687.5
      if (this.isOnlyPartOfSchoolYear) {
        hoursInPeriod = parseFloat(this.numberOfSchoolDays * 7.5).toFixed(2)
      }
      this.workingHours.hours = hoursInPeriod
      this.workingHours.standardHours = hoursInPeriod
    },
    setStartDate (date) {
      this.startDate = date
      setTimeout(_ => {
        this.isEdit = false
      })
    },
    setEndDate (date) {
      this.endDate = date
      setTimeout(_ => {
        this.isEdit = false
      })
    },
    employmentPercentageChanged (val) {
      const percentage = (val / 100)
      this.hoursPerWeekChanged(percentage, true)
    },
    hoursPerWeekChanged (val, changePercentage) {
      let employmentRate = val
      let percentage = employmentRate * 100
      if (changePercentage) {
        percentage = percentage.toFixed(0)
        this.employmentPercentage.hours = percentage
      }
      this.workingHours.hours = parseFloat(this.workingHours.standardHours * employmentRate).toFixed(2)
      this.planleggingsdager.hours = parseFloat(this.planleggingsdager.standardHours * employmentRate).toFixed(2)
      const idx = this.standardItems.findIndex(standardItem => standardItem.id === 'reduction_employee_percentage')
      if (percentage < 100) {
        this.standardItems[idx].hours = 100 - percentage
        this.standardItems[idx].isSelected = true
      } else {
        this.standardItems[idx].hours = 0
        this.standardItems[idx].isSelected = false
      }
    },
    onEditWorkingHours (value) {
      this.workingHours.standardHours = value
      this.workingHours.isFixed = false
    },
    onEditPlanleggingsdager (value) {
      this.planleggingsdager.standardHours = value
      this.planleggingsdager.isFixed = false
    },
    setSubtractedItemValue (item, value) {
      const idx = this.standardItems.findIndex(standardItem => standardItem.id === item.id)
      if (item.userStandardHours) {
        this.standardItems[idx].userStandardHours = value * 1
      }
      if (!item.standardHours || item.standardHours * 1 !== value * 1) {
        this.standardItems[idx].isFixed = false
      } else {
        this.standardItems[idx].isFixed = true
      }
    },
    setItemValue (item, idx, value) {
      if (!this.items[idx].standardHours || this.items[idx].standardHours * 1 !== value * 1) {
        this.items[idx].isFixed = false
      } else {
        this.items[idx].isFixed = true
      }
    },
    setIsAddNew (bool) {
      if (bool) {
        this.isAddNew = true
        this.$nextTick(_ => {
          this.$refs.add_new_input.focus()
        })
      } else {
        this.isAddNew = false
      }
    },
    addFromStandard (item) {
      const idx = this.standardItems.findIndex(standardItem => standardItem.id === item.id)
      this.standardItems[idx].isSelected = true
    },
    addOwn (item) {
      const newItem = {
        id: 'reduction_' + new Date().getTime(),
        title: this.newItemTitle,
        hours: 0,
        unit: '%',
        isFixed: false,
        isSelected: true,
        isOwn: true
      }
      if (item && item.title) {
        newItem.id = item.title
        newItem.title = item.title
        newItem.hours = item.value * 1
      }
      this.standardItems.push(newItem)
      this.reset()
    },
    deleteItem (item) {
      const idx = this.standardItems.findIndex(standardItem => standardItem.id === item.id)
      if (item.isOwn) {
        this.standardItems.splice(idx, 1)
        return
      }
      this.standardItems[idx].hours = this.standardItems[idx].standardHours
      this.standardItems[idx].isFixed = true
      this.standardItems[idx].isSelected = false
    },
    reset () {
      this.newItemTitle = ''
      this.isAddNew = false
    },
    initStartAndEndDate () {
      this.startDate = moment(this.schoolYear.student_time_start)
      this.endDate = moment(this.schoolYear.student_time_end)
      this.initStartDate = this.startDate.clone()
      this.initEndDate = this.endDate.clone()
    }
  },
  beforeMount () {
    this.initStartAndEndDate()
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.add-more__dropdown {
  display: inline-flex;
}

.items__item__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.items__item__content--error {
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 0px 0px 2px rgb(255 90 90 / 100%) !important;
  margin: -2px;
  padding: 2px;
}

.items__item__content--error + .input-error {
  font-weight: normal !important;
}

.items__item .d-input-group__input__close {
  transform: scale(0);
  width: 16px;
  height: 16px;
  font-size: 12px;
  transition: transform 0.25s;
  margin-right: 0.25rem;
}

.subtract-item:hover .d-input-group__input__close {
  transform: scale(1);
}

.items__item > input[type="number"] {
  width: 150px;
  font-weight: normal;
  background: #fff;
}

.items__item__add {
  color: var(--blue);
  cursor: pointer;
  font-size: 11px;
  font-weight: normal;
}

.items__item__add:hover {
  text-decoration: underline;
}

.items__item.items__item__add__new {
  flex-direction: column;
  font-weight: normal;
  margin-top: 1rem;
}

.items__item.items__item__add__new .items__item__add__new__buttons {
  margin-top: 0.5rem;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 0.5rem;
}

.input-group__input {
  display: flex;
  align-items: center;
  font-weight: normal;
}

.input-group__input .label {
  font-size: 0.85rem;
  margin-right: 5px;
}

.input-group__input > .icon__bg-circle {
  min-width: 30px;
  min-height: 30px;
}

.subtract-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: normal;
  margin-bottom: 0.5rem;
}

.subtract-item__title {
  display: flex;
  align-items: center;
}

.subtract-item .input-group__input input {
  padding: 6px 9px;
}

.item__total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ccc;
  border-width: 1px 0 1px 0;
  padding: 0.5rem;
  margin: 1rem 0;
}

.d-label__headline {
  margin: 0.5rem;
}

input {
  background: #fff;
}

.number-of-days-explainer {
  text-align: right;
  margin-bottom: 0.5rem;
}

.items__item--fixed > .items__item__content > .input-group__input > input[type="number"],
.subtract-item.subtract-item--fixed .input-group__input > input[type="number"] {
  background: #eeeeee;
}

.items__item--fixed > .items__item__content > .input-group__input > input[type="number"]:focus {
  background: #ffffff;
}

.calc-method {
  font-weight: normal;
  border: 1px solid #facc17;
  border-radius: 4px;
  background-color: #fefce8;
  padding: 0.5rem;
  margin-bottom: 1rem;
  font-size: 11px;
  line-height: 1.5;
  color: #a26206;
}

.calc-method p,
.calc-method h3 {
  margin: 0.5rem 0.25rem;
}

.calc-method__label {
  text-transform: initial;
  font-size: 11px;
  line-height: 1.2 !important;
  color: #a26206 !important;
  letter-spacing: 0 !important;
}

.subtract-item.items__item .input-group__input {
  width: 85px;
}
</style>



// WEBPACK FOOTER //
// ArbeidsplanAssignHoursNormList.vue?7431f5ca